import { fetchGet } from "../../../../common/util/fetch";
import { RecentMessagesResponse } from "./types";

export async function fetchRecentMessages(
    myUserId: number,
    targetUserId: number,
    num: number
): Promise<RecentMessagesResponse> {
    return fetchGet<
        { myUserId: number; targetUserId: number; num: number },
        RecentMessagesResponse
    >("api/Message/GetRecentMessages", { myUserId, targetUserId, num });
}
